"use strict";

import angular from "angular";

import template from "./help-item-multi-topics.component.html";
import "./themes/help-item-multi-topics.component.scss";
import "./themes/help-item-multi-topics-dark.component.scss";

class HelpItemMultiTopicsComponent {
    constructor() {}

    $onInit() {}

    $onDestroy() {}

    $onChanges(changes) {}
}

HelpItemMultiTopicsComponent.$inject = [];

const name = "helpItemMultiTopicsComponent";
const def = {
    bindings: {
        content: "<"
    },
    controller: HelpItemMultiTopicsComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
